import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { iconButtonStyles } from '../../styles/commonStyles';
import ButtonWithIcon from './ButtonWithIcon';

const CloseButton = ({ onClick }) => (
    <ButtonWithIcon
        Icon={AiOutlineClose}
        onClick={onClick}
        className={iconButtonStyles}
    />
);

export default CloseButton;
